import { Injectable } from "@angular/core";
import {
	MatLegacySnackBar as MatSnackBar,
	MatLegacySnackBarRef as MatSnackBarRef,
	LegacySimpleSnackBar as SimpleSnackBar,
} from "@angular/material/legacy-snack-bar";

@Injectable({
	providedIn: "root",
})
export class AlertService {
	constructor(private _snackBar: MatSnackBar) {}

	public openSnackBar(
		message: string,
		actionText: string = null,
		duration: number = 0,
	): MatSnackBarRef<SimpleSnackBar> {
		if (!actionText) actionText = "DISMISS";
		if (duration <= 0) duration = 3000;

		return this._snackBar.open(message, actionText, {
			duration: duration,
		});
	}
	public dismissVisibleSnackBar(): void {
		this._snackBar.dismiss();
	}
}
